import getRadiologistCaseRatio from "@custom/rtk-apis/analytics/getRadiologistCaseRatio";
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  status:"",
  result:null,
  msg:"",
  loading:false,
  error:""
};

const getRadiologistCaseRatioSlice = createSlice({
  name: "getRadiologistCaseRatioSlice",
  initialState,
  reducers: {
    clearRadiologistCaseRatio: state => {
      state.status = '';
      state.result = '';
      state.msg = '';
      state.loading = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getRadiologistCaseRatio.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(getRadiologistCaseRatio.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.status = "SUCCESS";
        state.result = payload;
        state.msg = payload.msg;
      })
      .addCase(getRadiologistCaseRatio.rejected, (state, { payload }) => {
        state.result = payload;
        state.loading = false;
      });
  },
});

export default getRadiologistCaseRatioSlice.reducer;
export const { clearRadiologistCaseRatio } = getRadiologistCaseRatioSlice.actions;
